/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from "react";
import { useLayout } from "../core";
import { FormattedMessage, useIntl } from "react-intl";
import clsx from "clsx";

interface FooterProps {
  mode?: string;
}

const Footer: FC<FooterProps> = ({ mode }) => {
  const { classes } = useLayout();
  const intl = useIntl();

  const openInNewTab = async () => {
    const applicationUrl = process.env.REACT_APP_APPLICATION_URL || "";
    window.open(
      `${applicationUrl.replace("https://", "https://static.")}/ug/user-guide_${intl.locale}.pdf`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <div className='footer py-4 d-flex flex-lg-column' id='kt_footer'>
      {/* begin::Container */}
      <div
        className={clsx(
          classes.footerContainer,
          "d-flex flex-column flex-md-row align-items-center",
          mode === "login" ? "justify-content-center" : "justify-content-between"
        )}
      >
        {/* begin::Copyright */}
        <div className='text-dark order-2 order-md-1'>
          <span className='text-muted fw-bold'>{new Date().getFullYear()} &copy;</span>
          <span className='text-muted fw-bold ms-2'>
            lux-sign <FormattedMessage id={"GLOBAL.POWERED_BY"} />{" "}
            <a
              target='_blank'
              rel='noreferrer'
              href='https://www.chambre-immobiliere.lu/'
              className='text-hover-primary'
            >
              Chambre Immobilière
            </a>
            <span> x </span>
            <a
              target='_blank'
              rel='noreferrer'
              href='https://www.luxtrust.com/'
              className='text-hover-primary'
            >
              LuxTrust
            </a>
            <span> x </span>
            <a
              target='_blank'
              rel='noreferrer'
              href='https://www.kodehyve.com/'
              className='text-hover-primary'
            >
              kodehyve
            </a>
          </span>
        </div>
        {/* end::Copyright */}

        {/* begin::Nav */}
        {mode !== "login" && (
          <ul className='menu menu-gray-600 menu-hover-primary fw-bold order-1'>
            <li className='menu-item'>
              <a
                href='mailto:lux-sign-support@kodehyve.com'
                className='btn fs-7 menu-link ps-0 pe-5'
              >
                <FormattedMessage id={"GLOBAL.REPORT_BUG"} />
              </a>
            </li>

            <li className='menu-item'>
              <button
                id='feedback-button'
                className='btn fs-7 menu-link ps-0 pe-2'
                onClick={async () => openInNewTab()}
              >
                <FormattedMessage id={"GLOBAL.USER_GUIDE"} />
              </button>
            </li>
          </ul>
        )}
        {/* end::Nav */}
      </div>
      {/* end::Container */}
    </div>
  );
};

export { Footer };
